import { ACCENT, Eyebrow } from "@/components/ecommerce/shared";

const STORES = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `/media/stores/store-${n}.webp`);

function StoreCard({ src, hidden }) {
  return (
    <li aria-hidden={hidden || undefined} className="shrink-0 w-[300px] sm:w-[420px] rounded-2xl border border-zinc-200 bg-white overflow-hidden shadow-[0_24px_50px_-30px_rgba(22,18,15,0.45)]">
      <div aria-hidden className="flex items-center gap-1.5 px-3 h-7 border-b border-zinc-100 bg-zinc-50">
        <span className="h-2 w-2 rounded-full bg-zinc-300" /><span className="h-2 w-2 rounded-full bg-zinc-300" /><span className="h-2 w-2 rounded-full" style={{ background: ACCENT }} />
      </div>
      <img src={src} alt={hidden ? "" : "Homepage of a South African online store Rekisa helped empower"} loading="lazy" decoding="async"
        width="960" height="600" className="block w-full aspect-[16/10] object-cover object-top" />
    </li>
  );
}

export default function EcomStores() {
  return (
    <section id="stores" aria-labelledby="stores-heading" data-testid="ecom-stores-section" className="relative py-16 sm:py-20 bg-white border-b border-zinc-200 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 mb-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <Eyebrow>Our work</Eyebrow>
          <h2 id="stores-heading" className="font-display text-3xl sm:text-4xl font-black tracking-[-0.03em] leading-[1.05] text-zinc-900">Online Stores We've Helped Empower</h2>
        </div>
        <p className="text-zinc-600 max-w-md leading-relaxed">Real South African brands selling online with storefronts, catalogues and checkout set up with Rekisa's support.</p>
      </div>
      <div className="relative" data-testid="ecom-stores-marquee">
        <div aria-hidden className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 z-10 bg-gradient-to-r from-white to-transparent" />
        <div aria-hidden className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 z-10 bg-gradient-to-l from-white to-transparent" />
        <ul className="animate-marquee-x flex w-max gap-5 pr-5 py-2" style={{ animationDuration: "85s" }}>
          {STORES.map((s) => <StoreCard key={s} src={s} />)}
          {STORES.map((s) => <StoreCard key={`dup-${s}`} src={s} hidden />)}
        </ul>
      </div>
    </section>
  );
}
